<template>
  <base-button
    class="tiny-button"
    :text="text"
    :is-disabled="false"
    :is-loading="false"
  >
  </base-button>
</template>

<script setup lang="ts">
import BaseButton from '@/components/common/BaseButton.vue'

export interface Props {
  text: string;
}
defineProps<Props>()
</script>

<style lang="scss">
.tiny-button {
  padding: 0.6em 1em;
  color: $purple;
  background-color: $white;
  border: 2px solid $white;
  font-family: $font-medium;
  font-size: 14px;
  line-height: 1.4em;
  border: none;
  transition: color 150ms $animationCurve;

  &:hover {
    color: $purple-light;
    border: none;
  }
}
</style>
